(ns common.schema.entities.workspace.kyc.templates.demo.company-config)

(def contact-email "kyc@zapflow.xyz")

(def svg-logo "")

(def png-logo "/img/zapflow-logo_color-RGB.png")

(def form-preface-text
  {:fi (str "<p>Rahastojen hoitajana Zapflow:lla on laissa säädetty velvollisuus tuntea ja tunnistaa sijoittajansa. "
            "Zapflown tulee aina noudattaa rahanpesun estämistä ja veroraportointia koskevaa lainsäädäntöä. "
            "Rahanpesun estämistä koskeva sääntely edellyttää, että Zapflow kerää muun muassa sijoittajan "
            "taloudelliseen tilaan, varojen alkuperään sekä tosiasiallisiin edunsaajiin liittyviä tietoja "
            "ennen asiakassuhteen aloittamista tai liiketoimen toteuttamista. "
            "Jos sijoittaja kieltäytyy toimittamasta Zapflowlle pakollisia tietoja, Zapflow voi joutua "
            "pidättäytymään liikesuhteeseen ryhtymisestä tai normaalin liiketoimintasuhteen ylläpitämisestä "
            "sijoittajan kanssa. "
            "Huomioithan, että lisätietoja voidaan tarvittaessa vaatia sijoittajan yhtiömuodosta, "
            "kotipaikasta ja/tai tällä lomakkeella ilmoitetuista tiedoista riippuen.</p>"

            "<p>Veroraportointia koskeva sääntely puolestaan edellyttää, että Zapflow kerää tietoja esimerkiksi "
            "sijoittajan verotusmaasta ja veronumerosta. Kansainvälisen verolainsäädännön (FATCA, CRS ja DAC2) "
            "mukaisesti Zapflow on velvollinen selvittämään, missä maassa/maissa sijoittaja ja sen "
            "tosiasialliset edunsaajat ovat verovelvollisia.</p>"

            "<p>Sijoittajan tuntemista varten kerättyjä tietoja käsitellään EU:n yleisen tietosuoja-asetuksen "
            "mukaisesti. Sijoittajalla on aina oikeus pyytää hänestä tallennetut henkilötiedot nähtäviksi. "
            "Sijoittajalla on oikeus kieltää Zapflowta kohdistamasta häneen markkinointitoimenpiteitä. "
            "Lisätietoja siitä, miten markkinoinnin voi kieltää, sekä koko tietosuojaseloste on "
            "saatavilla Zapflown verkkosivuilla osoitteessa: "
            "<a href=\"https://www.zapflow.com/gdpr\">https://www.zapflow.com/gdpr</a></p>")

   :en (str "<p>As a Fund Manager, Zapflow has a legal obligation to know and identify its investors. "
            "Zapflow must always comply with applicable anti-money laundering and tax reporting regulations. "
            "Anti-money laundering regulations require Zapflow to collect information e.g. on each "
            "Investor’s financial status, source of funds and ultimate beneficial owners before establishing "
            "a client relationship or conducting a transaction. In case the investor refuses to provide "
            "Zapflow with any obligatory information, Zapflow may not be able to enter into a business "
            "relationship or to operate in a normal course of business with the investor. "
            "Please note that additional information relating to the investor’s type of business entity, "
            "jurisdiction, and/or information provided in this form may be requested.</p>"

            "<p>Tax reporting regulations require Zapflow to collect information such as an investor’s tax "
            "residence and tax\nidentification numbers. In accordance with international tax regulation "
            "(FATCA, CRS and DAC2) Zapflow is\nobligated to know in which country/countries the investor "
            "and its Ultimate Beneficial Owners have tax residency.</p>"

            "<p>The personal data collected for the purpose of client identification will be processed in "
            "accordance with EU’s\nGeneral Data Protection Regulation. The investor has the right to request "
            "the personal data stored of him/her in the register for inspection at all times. "
            "Personal data will not be disclosed to third parties without a legitimate reason. "
            "The investor has the right to deny Zapflow from targeting marketing measures to him/her. "
            "More information on how to deny Zapflow from targeting marketing measures and the full privacy "
            "notice is available on Zapflow’s webpage:"
            "<a href=\"https://www.zapflow.com/gdpr\">https://www.zapflow.com/gdpr</a></p>")})
